module.exports = __webpack_public_path__ + "static/media/ABN-network.ae55a1f5.gif";